import { getDTTraceId } from '@/infra/logs/dynatrace';

export const MetaTracer = () => {
  const DTTraceId = getDTTraceId();

  return <meta dt-content={DTTraceId} itemProp="traceId" />;
};
